import { api } from 'services/api';
import { listTisType } from 'store/typesActions/types';

export const getTis = () => async (dispatch) => {
	dispatch({ type: listTisType.LIST_TIS_REC });
	try {
		const res = await api.get('/tis');
		const { data } = res || {};
		dispatch({
			type: listTisType.LIST_TIS_REC_SUCCESS,
			payload: data
		});
		return data;
	} catch (error) {
		const { response } = error;
		if (response && response.status === 400) {
			const { message } = response.data;
			dispatch({
				type: listTisType.LIST_TIS_REC_ERROR,
				payload: { errors: { message } }
			});
		} else {
			dispatch({
				type: listTisType.LIST_TIS_REC_ERROR,
				payload: {
					errors: { message: 'Erro desconhecido. Tente novamente mais tarde' }
				}
			});
		}
	}
};
